import { Outlet } from 'react-router-dom'

export default function JoinPage() {
  return <Outlet />
}
